import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const SchoolDetails = combineReducers({
  fetchSchoolRequest: createRequestReducer('SCHOOL:FETCH', {
    pending: true
  }),
  uploadAvatarRequest: createRequestReducer('SCHOOL:UPLOAD_AVATAR'),
  removeAvatarRequest: createRequestReducer('SCHOOL:REMOVE_AVATAR'),
  uploadCoverRequest: createRequestReducer('SCHOOL:UPLOAD_COVER'),
  removeCoverRequest: createRequestReducer('SCHOOL:REMOVE_COVER'),
  updateAccountRequest: createRequestReducer('SCHOOL:UPDATE'),
  school: createReducer(null, {
    'SCHOOL:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account.teacher_type.school,
    'SCHOOL:UPDATE_REQUEST_SUCCESS': (state, { params, response }) => {
      return {
        ...state,
        description: params.data.description,
        hide_year_group: params.data.hide_year_group,
        website: params.data.website,
        twitter_handler: params.data.twitter_handler
      }
    },
    'SCHOOL:UPLOAD_AVATAR_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      logo_url: response.data.school.logo_url
    }),
    'SCHOOL:REMOVE_AVATAR_REQUEST_SUCCESS': state => ({
      ...state,
      logo_url: null
    }),
    'SCHOOL:UPLOAD_COVER_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      background_image_url: response.data.school.background_image_url
    }),
    'SCHOOL:REMOVE_COVER_REQUEST_SUCCESS': state => ({
      ...state,
      background_image_url: null
    })
  })
})

export default SchoolDetails
